import { Field, RuleType, Option } from "react-querybuilder"

export function replaceNamesWithLabels(naturalLangQuery: string, fields: Field[]): string {
  let updatedQuery = naturalLangQuery
  fields.forEach((field) => {
    updatedQuery = updatedQuery.replace(new RegExp(field.name, "g"), field.label)
  })
  return updatedQuery
}

export const getValueLabels = (rule: RuleType, fields: Field[]) => {
  const fieldConfig = fields.find((f) => f.name === rule.field)
  if (fieldConfig?.values) {
    const val = (fieldConfig.values as Option[]).find((v) => v.name === rule.value)
    return val?.label || rule.value
  }

  return rule.value
}


// const translations = {
//   fields: 'Campi',
//   operators: 'Operatori',
//   value: 'Valore',
//   removeRule: 'Rimuovi regola',
//   removeGroup: 'Rimuovi gruppo',
//   addRule: 'Aggiungi regola',
//   addGroup: 'Aggiungi gruppo',
//   combinators: 'Combinatori',
//   notToggle: 'Negazione',
//   cloneRule: 'Clona regola',
//   cloneRuleGroup: 'Clona gruppo',
  
//   // aggiungi altre traduzioni se necessario
// };